$( document ).ready(function() {

    AOS.init();

    if ($(window).width() > 1037) {
        var body = $("body").outerWidth();
        var contain = $(".header.page-width").innerWidth();
        var less = body - contain;
        var total = less / 2;
        $(".hero-banner .container-full").css('margin-left', total);
    }

    $('.text-slider').owlCarousel({
        items: 1.5,
        loop:true,
        nav:false,
        dots:false,
        autoplay: true,
        autoWidth:true,
        slideTransition: 'linear',
        autoplayTimeout: 8000,
        autoplaySpeed: 8000,
        autoplayHoverPause: true,
        responsive:{
        0:{
            margin:30,
        },
        992:{
            margin:90,
        }
        }
    });

    $('.review-slider').owlCarousel({
        center: true,
        loop:true,
        margin:40,
        nav: true,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0752/9444/1572/files/Icon.png'>","<img src='https://cdn.shopify.com/s/files/1/0752/9444/1572/files/Icon.png'>"],
        responsive:{
        0:{
            items:1,
        },
        600:{
            items:2,
        },
        1200:{
            items:2.7,
        },
        1600:{
            items:3.5,
        }
        }
    });

    if ($(window).width() > 1037) {
        var body = $("body").outerWidth();
        var contain = $(".header.page-width").innerWidth();
        var less = body - contain;
        var total = less / 2;
        $(".review-slider .owl-nav").css('margin-right', total);
    }

});


(function($){
    $(document).ready(function(){
    function initAccordion($container){
        var firstOpen = $container.data('first-open') === true || $container.data('first-open') === 'true';
        var allowMultiple = $container.data('allow-multiple') === true || $container.data('allow-multiple') === 'true';
        var alwaysOne = $container.data('always-one') === true || $container.data('always-one') === 'true';

        var $items = $container.find('.acc-item');

        // open first if required, or ensure at least one open if alwaysOne
        if($items.length){
        if(firstOpen || (!firstOpen && alwaysOne)){
            openItem($items.first(), $container, allowMultiple);
        }
        }

        $container.on('click', '.acc-btn', function(e){
        var $btn = $(this);
        var $item = $btn.closest('.acc-item');
        var isOpen = $btn.attr('aria-expanded') === 'true';

        if(isOpen){
            // try to close
            var openCount = $container.find('.acc-btn[aria-expanded="true"]').length;
            if(alwaysOne && openCount <= 1){
            // don't close last open item if alwaysOne
            return;
            }
            closeItem($item);
        } else {
            // open
            if(!allowMultiple){
            // close others first
            $container.find('.acc-item').not($item).each(function(){
                closeItem($(this));
            });
            }
            openItem($item, $container, allowMultiple);
        }
        });

        function openItem($item, $container, allowMultiple){
        var $btn = $item.find('.acc-btn');
        var $panel = $item.find('.acc-panel');
        $btn.attr('aria-expanded', 'true');
        $panel.attr('aria-hidden', 'false').slideDown(180);
        }

        function closeItem($item){
        var $btn = $item.find('.acc-btn');
        var $panel = $item.find('.acc-panel');
        $btn.attr('aria-expanded', 'false');
        $panel.attr('aria-hidden', 'true').slideUp(140);
        }
    }

    // initialize each accordion on page
    $('.accordion').each(function(){
        initAccordion($(this));
    });
    });
})(jQuery);